import {Product} from "@salla.sa/twilight/types/common"

export enum Sources {
    Header = "header",
    Footer = "footer",
    Json = "json",
}

export interface MenuContentDTO {
    id?:                 number;
    order?:              number;
    title?:              string;
    url?:                string;
    products?:           Product[];
    is_by_form_builder?: boolean;
    attrs?:              string;
    link_attrs?:         string;
    target?:             string;
    has_children?:       boolean;
    children?:           MenuContentDTO[];
}